// Copy text to the clipboard in a way that also works on plain-HTTP sites.
//
// navigator.clipboard only exists in a secure context (HTTPS or localhost), so
// on a plain-HTTP live deployment it is undefined and throws. We fall back to
// the legacy execCommand('copy') via a temporary textarea, which works over
// HTTP too. Returns true if the copy succeeded.
export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) {
    // Fall through to the legacy path below.
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (err) {
    return false;
  }
}
